import axios from "axios";
import { MainCard } from "../../../components/Card/Cards";
import { CustomInput, CustomTextArea } from "../../../components/Input/input";
import { Button } from "primereact/button";
import React, { useRef, useState } from "react";
import { API_BASE_URL } from "../../../utils/constants";
import { Toast } from "primereact/toast";

export default function EmergencyContact({ step, setStep }) {
  const toast = useRef(null);
  const [emergencyContact, setEmergencyContact] = useState([
    {
      name: "",
      address: "",
      phoneNumber: "",
      relation: "",
    },
    {
      name: "",
      address: "",
      phoneNumber: "",
      relation: "",
    },
  ]);

  const handleChange = ({ name, value, index }) => {
    setEmergencyContact((prev) =>
      prev?.map((item, i) => (i === index ? { ...item, [name]: value } : item))
    );
  };

  const submitData = async () => {
    let contact1 =
      emergencyContact[0].name !== "" &&
      emergencyContact[0].address !== "" &&
      emergencyContact[0].phoneNumber !== "" &&
      emergencyContact[0].relation !== "";
    let contact2 =
      emergencyContact[1].name !== "" &&
      emergencyContact[1].address !== "" &&
      emergencyContact[1].phoneNumber !== "" &&
      emergencyContact[1].relation !== "";
    if (contact1 && contact2) {
      try {
        const token = sessionStorage.getItem("token"); // Retrieve token from sessionStorage

        console.log("token", token);
        const response = await axios.post(
          API_BASE_URL + "/api/driver/emergency-contact",
          { emergencyContacts: emergencyContact, authToken: token },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          }
        );
        console.log(response);
        setStep((prev) => prev + 1);
      } catch (err) {
        alert(err.response?.data?.message || "Failed to save information");
      }
    } else
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill all required fields",
      });
  };

  return (
    <MainCard size="container">
      <Toast ref={toast} />
      <p>
        Please list the names, addresses, phone numbers and relationship of
        people you would like us to contact in case of emergency (only people
        you have known for at least a year). Include at least one relative. Any
        information Shah Transport gathers from these references will be held as
        confidential and not released to you, the applicant.
      </p>
      <h4>Persons to be notified in the event of an Emergency </h4>
      {emergencyContact?.map((contact, index) => (
        <div className="flex flex-wrap" key={index}>
          <h3 className="w-full pl-2">Person {index + 1}</h3>
          <CustomInput
            label="Name"
            required
            name="name"
            value={contact?.name}
            onChange={({ name, value }) => handleChange({ name, value, index })}
          />
          <CustomTextArea
            label="Address"
            required
            name="address"
            value={contact?.address}
            onChange={({ name, value }) => handleChange({ name, value, index })}
          />
          <CustomInput
            label="Phone Number"
            required
            name="phoneNumber"
            value={contact?.phoneNumber}
            onChange={({ name, value }) => handleChange({ name, value, index })}
          />
          <CustomInput
            label="Relation"
            required
            name="relation"
            value={contact?.relation}
            onChange={({ name, value }) => handleChange({ name, value, index })}
          />
          {index === 0 && <hr className="w-full m-5" />}
        </div>
      ))}
      <div className="flex justify-content-end mt-4 pr-2">
        <Button label="Save & Continue" onClick={submitData} />
      </div>
    </MainCard>
  );
}
